import {
  APP_DATA_SUCCESS,
  APP_CONFIG_SUCCESS,
} from '../actions/appActions';


export const config = (state = {}, action) => {
  switch (action.type) {
    case APP_CONFIG_SUCCESS:
      return { ...action.payload };
    default:
      return state;
  }
};

export const sections = (state = {}, action) => {
  switch (action.type) {
    case APP_DATA_SUCCESS:
      return { ...action.payload.sections };
    default:
      return state;
  }
};

export const project = (state = {}, action) => {
  switch (action.type) {
    case APP_DATA_SUCCESS:
      return { ...action.payload.project };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/appReducers.js